module.exports = __webpack_public_path__ + "static/media/CO-off.fad607dd.svg";